import React from 'react';
import moment from 'moment';
import {getRowDataForColumnComponent} from 'js/common/griddle_column_helper';

const Flight = viewFlightUrl => props => {
    const {
        flight_id,
        flight_label,
        flight_start_date,
        flight_end_date,
        invite_email_sent,
        ops_approved_at
    } = getRowDataForColumnComponent(props);
    return (
        <div>
            <div>
                <a
                    href={viewFlightUrl.replace('__ID__', flight_id)}
                    title={flight_label}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {flight_label}
                </a>
            </div>
            <div>
                <b>Start:</b>
                &nbsp;
                {moment
                    .utc(flight_start_date)
                    .local()
                    .format('MM/DD/YYYY h:mma')}
            </div>
            <div>
                <b>End:</b>
                &nbsp;
                {moment
                    .utc(flight_end_date)
                    .local()
                    .format('MM/DD/YYYY h:mma')}
            </div>
            <div>
                {invite_email_sent
                    ? `Invited at: ${moment(invite_email_sent)
                          .local()
                          .format('MM/DD/YYYY h:mma')}`
                    : 'Invited at: N/A'}
            </div>
            <div>
                {ops_approved_at
                    ? `Ops Approved at: ${moment(ops_approved_at)
                          .local()
                          .format('MM/DD/YYYY h:mma')}`
                    : 'Ops Approved at: N/A'}
            </div>
        </div>
    );
};

export default Flight;



// WEBPACK FOOTER //
// ./admin_operations/shipping/components/flight.js